__turbopack_context__.v({
  "className": "DR7pUa_className",
  "variable": "DR7pUa_variable",
});
